var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#C6CCDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7097 10.3069L15 14.0207L11.2903 10.3069C10.8812 9.89771 10.2171 9.89771 9.80687 10.3069C9.39771 10.716 9.39771 11.377 9.80687 11.7861L13.5165 15.5L9.80687 19.2139C9.39771 19.623 9.39771 20.284 9.80687 20.6931C10.2171 21.1023 10.8812 21.1023 11.2903 20.6931L15 16.9793L18.7097 20.6931C19.1188 21.1023 19.7829 21.1023 20.1931 20.6931C20.6023 20.284 20.6023 19.623 20.1931 19.2139L16.4835 15.5L20.1931 11.7861C20.6023 11.377 20.6023 10.716 20.1931 10.3069C19.7829 9.89771 19.1188 9.89771 18.7097 10.3069Z",
    fill: "#757783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.fb2355ef.svg";
export { ForwardRef as ReactComponent };